import { useQuery } from '@tanstack/vue-query';
import { getMeV3 } from '@/api/users.v3';
import type { ApiMeV3 } from '@/types/users.v3';
import { getMeV3QueryKey } from '@/utils/queries/users';

/**
 * Shared v3 `/me` query options, used by both useMeV3Query and session bootstrap.
 * A v3 `/me` failure must not toast — session bootstrap already treats a v3
 * outage as non-fatal, so the global query error handler is told to skip it.
 */
export function getMeV3QueryOptions() {
  return {
    queryKey: getMeV3QueryKey(),
    queryFn: getMeV3,
    staleTime: Infinity,
    retry: false,
    meta: {
      errorToast: {
        disabled: true,
      },
    },
  };
}

/**
 * v3 `/me` for the permissions store. Always fetched. The flag decides whether
 * the store reads it.
 */
export function useMeV3Query() {
  return useQuery({
    ...getMeV3QueryOptions(),
    select: (me: ApiMeV3) => ({
      ...me,
      teams: [...(me.teams ?? [])].sort((a, b) => a.name.localeCompare(b.name)),
      permission_grants: me.permission_grants ?? [],
    }),
  });
}
